import module from 'fanconsultores/module.js'
import template from './template.html'

class AdminWelcomeComponent {
  constructor ($api, $state) {
    this.$api = $api
    this.$state = $state
  }

  $start () {
    this.$api.auth().then(() => (this.$state.go('dashboard', {}, {location: 'replace'})))
  }
}

module.component('adminWelcome', {
  controller: AdminWelcomeComponent,
  template,
})



// WEBPACK FOOTER //
// ./src/fanconsultores/components/admin/welcome/component.js